import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class BdspCustomListService extends BaseEntityService {

  private resource_url = `${this.BASE_BDSP_URL}/custom-list/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }
}
